/**
 * What a client's held-for-authorization items say is uncovered: each payer and code, with the
 * service dates no authorization covers. One line per payer and code rather than per item, because
 * one authorization letter covers a code for a payer across a period.
 *
 * @param {import('../model/BillingItem.types').BillingItem[]} items - held for authorization
 * @returns {{fundingSourceId: string|null, billingCode: string|null, from: string, to: string, count: number}[]}
 *   ordered by payer, then code
 */
// eslint-disable-next-line import/prefer-default-export
export function uncoveredServices(items) {
  const lines = new Map();

  items.forEach((item) => {
    const key = `${item.fundingSourceId ?? ''}|${item.billingCode ?? ''}`;
    const line = lines.get(key);

    if (!line) {
      lines.set(key, {
        fundingSourceId: item.fundingSourceId ?? null,
        billingCode: item.billingCode ?? null,
        from: item.serviceDate,
        to: item.serviceDate,
        count: 1,
      });
      return;
    }
    // Calendar dates compare as strings, so the earliest and latest need no parsing.
    line.from = item.serviceDate < line.from ? item.serviceDate : line.from;
    line.to = item.serviceDate > line.to ? item.serviceDate : line.to;
    line.count += 1;
  });

  return [...lines.values()].sort((a, b) => (a.fundingSourceId ?? '').localeCompare(b.fundingSourceId ?? '')
    || (a.billingCode ?? '').localeCompare(b.billingCode ?? ''));
} // uncoveredServices()
